import { render, staticRenderFns } from "./TableChartDisplay.vue?vue&type=template&id=b9b2915e&scoped=true"
import script from "./TableChartDisplay.vue?vue&type=script&lang=js"
export * from "./TableChartDisplay.vue?vue&type=script&lang=js"
import style0 from "./TableChartDisplay.vue?vue&type=style&index=0&id=b9b2915e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b2915e",
  null
  
)

export default component.exports